import {state as lifecycle} from 'fragments/lifecycle';

export default {
	...lifecycle,
	initialized: false,
	processing: false,
	mcpConnections: [],
	mcpConnectionsLoading: false,
	mcpConnectionsLoadError: false,
	disconnectingClientIds: {},
};
